import {
  sendAnalyticsInfo,
  sendAnalyticsError,
  sendAnalyticsWarning,
} from 'features/analytics/helpers';
import type { AppDispatch } from 'features/app/store/store';

export interface ConnectionStartAnalyticsPayload {
  sessionId: string;
  instanceNumber: number;
  totalConnections: number;
  activeConnections: number;
}

export interface ConnectionCloseAnalyticsPayload {
  instanceNumber: number;
  totalConnections: number;
  activeConnections: number;
}

export interface WebSocketOpenAnalyticsPayload {
  sessionId: string;
  wsUrl: string;
  eventType: string;
  eventTimestamp: number;
}

export interface WebSocketErrorAnalyticsPayload {
  sessionId: string;
  wsUrl: string;
  readyState: number;
  eventType: string;
  eventTimestamp: number;
}

export interface WebSocketCloseAnalyticsPayload {
  sessionId: string;
  wsUrl: string | undefined;
  code: number;
  reason: string;
  wasClean: boolean;
  eventType: string;
  eventTimestamp: number;
  readyState: number | undefined;
}

export function dispatchConnectionStartAnalytics(
  dispatch: AppDispatch,
  payload: ConnectionStartAnalyticsPayload
) {
  dispatch(
    sendAnalyticsInfo({
      Method: 'TrainingConnectionSavvy.startConnection',
      eventName: 'training_forker_connection_start',
      details: payload,
      logGroup: 'training_forker',
    })
  );
}

export function dispatchConnectionCloseAnalytics(
  dispatch: AppDispatch,
  payload: ConnectionCloseAnalyticsPayload
) {
  dispatch(
    sendAnalyticsInfo({
      Method: 'TrainingConnectionSavvy.closeConnection',
      eventName: 'training_forker_connection_close',
      details: payload,
      logGroup: 'training_forker',
    })
  );
}

export function dispatchWebSocketOpenAnalytics(
  dispatch: AppDispatch,
  payload: WebSocketOpenAnalyticsPayload
) {
  dispatch(
    sendAnalyticsInfo({
      Method: 'TrainingConnectionSavvy.WebSocketOpen',
      eventName: 'training_forker_ws_open',
      details: payload,
      logGroup: 'training_forker',
    })
  );
}

export function dispatchWebSocketErrorAnalytics(
  dispatch: AppDispatch,
  payload: WebSocketErrorAnalyticsPayload
) {
  dispatch(
    sendAnalyticsError({
      Method: 'TrainingConnectionSavvy.WebSocketError',
      eventName: 'training_forker_ws_error',
      details: payload,
      logGroup: 'training_forker',
    })
  );
}

export function dispatchWebSocketCloseAnalytics(
  dispatch: AppDispatch,
  payload: WebSocketCloseAnalyticsPayload
) {
  dispatch(
    sendAnalyticsInfo({
      Method: 'TrainingConnectionSavvy.WebSocketClose',
      eventName: 'training_forker_ws_close',
      details: payload,
      logGroup: 'training_forker',
    })
  );
}

export interface RetryAttemptAnalyticsPayload {
  sessionId: string;
  attempt: number;
  maxAttempts: number;
  delayMs: number;
  wsUrl: string;
}

export interface RetryExhaustedAnalyticsPayload {
  sessionId: string;
  totalAttempts: number;
  wsUrl: string;
}

export function dispatchRetryAttemptAnalytics(
  dispatch: AppDispatch,
  payload: RetryAttemptAnalyticsPayload
) {
  dispatch(
    sendAnalyticsInfo({
      Method: 'TrainingConnectionSavvy.RetryAttempt',
      eventName: 'training_forker_ws_retry_attempt',
      details: payload,
      logGroup: 'training_forker',
    })
  );
}

export function dispatchRetryExhaustedAnalytics(
  dispatch: AppDispatch,
  payload: RetryExhaustedAnalyticsPayload
) {
  dispatch(
    sendAnalyticsError({
      Method: 'TrainingConnectionSavvy.RetryExhausted',
      eventName: 'training_forker_ws_retry_exhausted',
      details: payload,
      logGroup: 'training_forker',
    })
  );
}

export interface QualityDegradedAnalyticsPayload {
  reason: string;
  peerId: string;
  videoBitrate?: number;
  videoJitter?: number;
  videoFramesPerSecond?: number;
  videoRoundTripTime?: number;
}

export function dispatchQualityDegradedAnalytics(
  dispatch: AppDispatch,
  payload: QualityDegradedAnalyticsPayload
) {
  dispatch(
    sendAnalyticsWarning({
      Method: 'useTrainingForkerQualityMonitor.qualityDegradedDetected',
      eventName: 'training_forker_quality_degraded',
      details: payload,
      logGroup: 'training_forker',
    })
  );
}

export interface ForkStoppedQualityAnalyticsPayload {
  reason: string;
  sipCallId?: string;
}

export function dispatchForkStoppedQualityAnalytics(
  dispatch: AppDispatch,
  payload: ForkStoppedQualityAnalyticsPayload
) {
  dispatch(
    sendAnalyticsWarning({
      Method: 'useTrainingForker.stopForkingDueToQuality',
      eventName: 'training_forker_fork_stopped_quality',
      details: payload,
      logGroup: 'training_forker',
    })
  );
}
